import { all, call, fork, put, takeEvery } from 'redux-saga/effects';
import { authFB } from '../../../helpers/Firebase';
import { servicePath } from '../../../constants/defaultValues';
import { TI_LIST, TI_ADD, TI_FILTER_TASK_STATUS, TI_FILTER_SUPPLIERS } from '../../actions';
import { TaskInspectionListSuccess, TaskInspectionListError, TaskInspectionAddSuccess, TaskInspectionAddError, TaskInspectionFilterTaskStatusSuccess, TaskInspectionFilterSuppliersSuccess } from '../../actions';

function getToken(auth) {
  return new Promise((resolve, reject) => {
    const unsubscribe = auth.onAuthStateChanged(user => {
      user.getIdToken().then((token) => { unsubscribe(); resolve(token); });
    }, reject);
  });
}

const onListAsync = async (payload) => {
  let token = await getToken(authFB);
  const response = await fetch(servicePath + 'delivery_plan/task_inspection/list', {
    method: 'POST', mode: 'cors', cache: 'no-cache',
    headers: { 'Content-Type': 'application/json', 'token': token },
    body: JSON.stringify(payload)
  }).then(r => r.json()).catch(err => console.log(err));
  return { data: response };
};

const onAddAsync = async (payload) => {
  let token = await getToken(authFB);
  const response = await fetch(servicePath + 'delivery_plan/task_inspection/add', {
    method: 'POST', mode: 'cors', cache: 'no-cache',
    headers: { 'Content-Type': 'application/json', 'token': token },
    body: JSON.stringify(payload)
  }).then(r => r.json()).catch(err => console.log(err));
  return { data: response };
};

const onFilterTaskStatusAsync = async () => {
  let token = await getToken(authFB);
  const response = await fetch(servicePath + 'search/delivery_plan/task_status', {
    method: 'POST', mode: 'cors', cache: 'no-cache',
    headers: { 'Content-Type': 'application/json', 'token': token },
    body: JSON.stringify({})
  }).then(r => r.json()).catch(err => console.log(err));
  return { data: response };
};

const onFilterSuppliersAsync = async () => {
  let token = await getToken(authFB);
  const response = await fetch(servicePath + 'search/delivery_plan/suppliers', {
    method: 'POST', mode: 'cors', cache: 'no-cache',
    headers: { 'Content-Type': 'application/json', 'token': token },
    body: JSON.stringify({})
  }).then(r => r.json()).catch(err => console.log(err));
  return { data: response };
};

function* onList(data) {
  try { const response = yield call(onListAsync, data.payload); yield put(TaskInspectionListSuccess(response.data)); }
  catch (error) { yield put(TaskInspectionListError(error)); }
}

function* onAdd(data) {
  try { const response = yield call(onAddAsync, data.payload); yield put(TaskInspectionAddSuccess(response.data)); }
  catch (error) { yield put(TaskInspectionAddError(error)); }
}

function* onFilterTaskStatus() {
  try { const response = yield call(onFilterTaskStatusAsync); yield put(TaskInspectionFilterTaskStatusSuccess(response.data.data || [])); }
  catch (error) { console.error(error); }
}

function* onFilterSuppliers() {
  try { const response = yield call(onFilterSuppliersAsync); yield put(TaskInspectionFilterSuppliersSuccess(response.data.data || [])); }
  catch (error) { console.error(error); }
}

export function* watchList() { yield takeEvery(TI_LIST, onList); }
export function* watchAdd() { yield takeEvery(TI_ADD, onAdd); }
export function* watchFilterTaskStatus() { yield takeEvery(TI_FILTER_TASK_STATUS, onFilterTaskStatus); }
export function* watchFilterSuppliers() { yield takeEvery(TI_FILTER_SUPPLIERS, onFilterSuppliers); }

export default function* rootSaga() {
  yield all([fork(watchList), fork(watchAdd), fork(watchFilterTaskStatus), fork(watchFilterSuppliers)]);
}
